import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "HotelsFillGreenOnBlue__IconWrapper",
  componentId: "sc-1s1sz16-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 51 44",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    filter: "url(#HotelsFillGreenOnBlue_tsx__a)"
  }, React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    fillRule: "evenodd",
    d: "M14.083 36V4.333h23.334V36z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.text.heading")(themeProps),
    fillRule: "evenodd",
    d: "M40.75 2.667a.833.833 0 0 1 .15 1.653l-.15.013h-1.667V36h4.167a.833.833 0 0 1 .15 1.653l-.15.014h-35a.833.833 0 0 1-.15-1.654L8.25 36h4.167v-2.927a4.1 4.1 0 0 1-1.458.691l-.204.026H9.084l-.206-.026a4.15 4.15 0 0 1-3.086-3.428 4.14 4.14 0 0 1 1.09-3.43l.186-.186-.063-.123a3.1 3.1 0 0 1-.273-1.04l-.01-.272a3.17 3.17 0 0 1 2.334-3.047l.258-.06a3.19 3.19 0 0 1 3.103 1.176V4.334H10.75a.833.833 0 0 1-.15-1.654l.15-.013zM37.417 36V4.333H14.083V36z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.pricePrimary.dark")(themeProps),
    fillRule: "evenodd",
    d: "M8.125 36.833h1.583v-4.166H8.125zm33.666 0h1.584v-4.166H41.79z",
    clipRule: "evenodd"
  }), React.createElement("mask", {
    id: "HotelsFillGreenOnBlue_tsx__b",
    width: 19,
    height: 19,
    x: 16.418,
    y: 6.667,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "M16.418 6.667h19v19h-19z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.25 7.667h1.668c.46 0 .833.373.833.833v1.667c0 .46-.373.833-.834.833h-1.666a.833.833 0 0 1-.834-.833V8.5c0-.46.374-.833.834-.833m6.666 0h1.666c.46 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833h-1.666a.833.833 0 0 1-.834-.833V8.5c0-.46.374-.833.834-.833m8.334 0h-1.667a.833.833 0 0 0-.833.833v1.667c0 .46.373.833.833.833h1.667c.46 0 .833-.373.833-.833V8.5a.833.833 0 0 0-.833-.833m-15 6.666h1.668c.46 0 .833.373.833.834v1.666c0 .46-.373.834-.834.834h-1.666a.833.833 0 0 1-.834-.834v-1.666c0-.46.374-.834.834-.834m8.333 0h-1.667a.833.833 0 0 0-.834.834v1.666c0 .46.374.834.834.834h1.666c.46 0 .834-.373.834-.834v-1.666a.833.833 0 0 0-.834-.834m5 0h1.667c.46 0 .833.373.833.834v1.666c0 .46-.373.834-.833.834h-1.667a.833.833 0 0 1-.833-.834v-1.666c0-.46.373-.834.833-.834M19.918 21H18.25a.833.833 0 0 0-.834.833V23.5c0 .46.374.833.834.833h1.666c.46 0 .834-.373.834-.833v-1.667a.833.833 0 0 0-.834-.833m4.998 0h1.666c.46 0 .834.373.834.833V23.5c0 .46-.373.833-.834.833h-1.666a.833.833 0 0 1-.834-.833v-1.667c0-.46.374-.833.834-.833m8.334 0h-1.667a.833.833 0 0 0-.833.833V23.5c0 .46.373.833.833.833h1.667c.46 0 .833-.373.833-.833v-1.667A.833.833 0 0 0 33.25 21",
    clipRule: "evenodd"
  })), React.createElement("path", {
    fill: themeGet("palette.primary.tint")(themeProps),
    fillRule: "evenodd",
    d: "M18.25 7.667h1.668c.46 0 .833.373.833.833v1.667c0 .46-.373.833-.834.833h-1.666a.833.833 0 0 1-.834-.833V8.5c0-.46.374-.833.834-.833m6.666 0h1.666c.46 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833h-1.666a.833.833 0 0 1-.834-.833V8.5c0-.46.374-.833.834-.833m8.334 0h-1.667a.833.833 0 0 0-.833.833v1.667c0 .46.373.833.833.833h1.667c.46 0 .833-.373.833-.833V8.5a.833.833 0 0 0-.833-.833m-15 6.666h1.668c.46 0 .833.373.833.834v1.666c0 .46-.373.834-.834.834h-1.666a.833.833 0 0 1-.834-.834v-1.666c0-.46.374-.834.834-.834m8.333 0h-1.667a.833.833 0 0 0-.834.834v1.666c0 .46.374.834.834.834h1.666c.46 0 .834-.373.834-.834v-1.666a.833.833 0 0 0-.834-.834m5 0h1.667c.46 0 .833.373.833.834v1.666c0 .46-.373.834-.833.834h-1.667a.833.833 0 0 1-.833-.834v-1.666c0-.46.373-.834.833-.834M19.918 21H18.25a.833.833 0 0 0-.834.833V23.5c0 .46.374.833.834.833h1.666c.46 0 .834-.373.834-.833v-1.667a.833.833 0 0 0-.834-.833m4.998 0h1.666c.46 0 .834.373.834.833V23.5c0 .46-.373.833-.834.833h-1.666a.833.833 0 0 1-.834-.833v-1.667c0-.46.374-.833.834-.833m8.334 0h-1.667a.833.833 0 0 0-.833.833V23.5c0 .46.373.833.833.833h1.667c.46 0 .833-.373.833-.833v-1.667A.833.833 0 0 0 33.25 21",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.text.heading")(themeProps),
    d: "M19.918 6.917H18.25v1.5h1.666zM21.5 8.5c0-.874-.71-1.583-1.584-1.583v1.5c.046 0 .084.037.084.083zm0 1.667V8.5H20v1.667zm-1.584 1.583c.875 0 1.584-.709 1.584-1.583H20a.083.083 0 0 1-.084.083zm-1.666 0h1.666v-1.5h-1.666zm-1.584-1.583c0 .874.71 1.583 1.584 1.583v-1.5a.083.083 0 0 1-.084-.083zm0-1.667v1.667h1.5V8.5zm1.584-1.583c-.875 0-1.584.709-1.584 1.583h1.5c0-.046.038-.083.084-.083zm8.331 0h-1.666v1.5h1.666zM28.167 8.5c0-.874-.709-1.583-1.584-1.583v1.5c.046 0 .084.037.084.083zm0 1.667V8.5h-1.5v1.667zm-1.584 1.583c.875 0 1.584-.709 1.584-1.583h-1.5a.083.083 0 0 1-.084.083zm-1.666 0h1.666v-1.5h-1.666zm-1.584-1.583c0 .874.71 1.583 1.584 1.583v-1.5a.083.083 0 0 1-.084-.083zm0-1.667v1.667h1.5V8.5zm1.584-1.583c-.875 0-1.584.709-1.584 1.583h1.5c0-.046.038-.083.084-.083zm6.667 1.5h1.667v-1.5h-1.667zM31.5 8.5c0-.046.037-.083.083-.083v-1.5C30.71 6.917 30 7.626 30 8.5zm0 1.667V8.5H30v1.667zm.083.083a.083.083 0 0 1-.083-.083H30c0 .874.709 1.583 1.583 1.583zm1.667 0h-1.667v1.5h1.667zm.083-.083a.083.083 0 0 1-.083.083v1.5c.874 0 1.583-.709 1.583-1.583zm0-1.667v1.667h1.5V8.5zm-.083-.083c.046 0 .083.037.083.083h1.5c0-.874-.709-1.583-1.583-1.583zm-13.332 5.166H18.25v1.5h1.666zm1.583 1.584c0-.875-.71-1.584-1.584-1.584v1.5c.046 0 .084.038.084.084zm0 1.666v-1.666H20v1.666zm-1.584 1.584c.875 0 1.584-.71 1.584-1.584H20a.083.083 0 0 1-.084.084zm-1.666 0h1.666v-1.5h-1.666zm-1.584-1.584c0 .875.71 1.584 1.584 1.584v-1.5a.083.083 0 0 1-.084-.084zm0-1.666v1.666h1.5v-1.666zm1.584-1.584c-.875 0-1.584.71-1.584 1.584h1.5c0-.046.038-.084.084-.084zm6.665 1.5h1.666v-1.5h-1.666zm-.084.084c0-.046.038-.084.084-.084v-1.5c-.875 0-1.584.71-1.584 1.584zm0 1.666v-1.666h-1.5v1.666zm.084.084a.083.083 0 0 1-.084-.084h-1.5c0 .875.71 1.584 1.584 1.584zm1.666 0h-1.666v1.5h1.666zm.084-.084a.083.083 0 0 1-.084.084v1.5c.875 0 1.584-.71 1.584-1.584zm0-1.666v1.666h1.5v-1.666zm-.084-.084c.046 0 .084.038.084.084h1.5c0-.875-.709-1.584-1.584-1.584zm6.668-1.5h-1.667v1.5h1.667zm1.583 1.584c0-.875-.709-1.584-1.583-1.584v1.5c.046 0 .083.038.083.084zm0 1.666v-1.666h-1.5v1.666zm-1.583 1.584c.874 0 1.583-.71 1.583-1.584h-1.5a.083.083 0 0 1-.083.084zm-1.667 0h1.667v-1.5h-1.667zM30 16.833c0 .875.709 1.584 1.583 1.584v-1.5a.083.083 0 0 1-.083-.084zm0-1.666v1.666h1.5v-1.666zm1.583-1.584c-.874 0-1.583.71-1.583 1.584h1.5c0-.046.037-.084.083-.084zM18.251 21.75h1.666v-1.5h-1.666zm-.084.083c0-.046.038-.083.084-.083v-1.5c-.875 0-1.584.709-1.584 1.583zm0 1.667v-1.667h-1.5V23.5zm.084.083a.083.083 0 0 1-.084-.083h-1.5c0 .875.71 1.583 1.584 1.583zm1.666 0h-1.666v1.5h1.666zm.084-.083a.083.083 0 0 1-.084.083v1.5c.875 0 1.584-.708 1.584-1.583zm0-1.667V23.5h1.5v-1.667zm-.084-.083c.046 0 .084.037.084.083h1.5c0-.874-.71-1.583-1.584-1.583zm6.665-1.5h-1.666v1.5h1.666zm1.584 1.583c0-.874-.709-1.583-1.584-1.583v1.5c.046 0 .084.037.084.083zm0 1.667v-1.667h-1.5V23.5zm-1.584 1.583c.875 0 1.584-.708 1.584-1.583h-1.5a.083.083 0 0 1-.084.083zm-1.666 0h1.666v-1.5h-1.666zM23.332 23.5c0 .875.71 1.583 1.584 1.583v-1.5a.083.083 0 0 1-.084-.083zm0-1.667V23.5h1.5v-1.667zm1.584-1.583c-.875 0-1.584.709-1.584 1.583h1.5c0-.046.038-.083.084-.083zm6.667 1.5h1.667v-1.5h-1.667zm-.083.083c0-.046.037-.083.083-.083v-1.5c-.874 0-1.583.709-1.583 1.583zm0 1.667v-1.667H30V23.5zm.083.083a.083.083 0 0 1-.083-.083H30c0 .875.709 1.583 1.583 1.583zm1.667 0h-1.667v1.5h1.667zm.083-.083a.083.083 0 0 1-.083.083v1.5c.874 0 1.583-.708 1.583-1.583zm0-1.667V23.5h1.5v-1.667zm-.083-.083c.046 0 .083.037.083.083h1.5c0-.874-.709-1.583-1.583-1.583z",
    mask: "url(#HotelsFillGreenOnBlue_tsx__b)"
  }), React.createElement("path", {
    fill: themeGet("palette.highlight.light")(themeProps),
    fillRule: "evenodd",
    d: "M33.25 7.667h-1.667a.833.833 0 0 0-.833.833v1.667c0 .46.373.833.833.833h1.667c.46 0 .833-.373.833-.833V8.5a.833.833 0 0 0-.833-.833M24.915 21h1.667c.46 0 .833.373.833.833V23.5c0 .46-.373.833-.833.833h-1.667a.833.833 0 0 1-.833-.833v-1.667c0-.46.373-.833.833-.833m6.668 0h1.667c.46 0 .833.373.833.833V23.5c0 .46-.373.833-.833.833h-1.667a.833.833 0 0 1-.833-.833v-1.667c0-.46.373-.833.833-.833m-13.332-6.667h1.667c.46 0 .833.373.833.834v1.666c0 .46-.373.834-.833.834h-1.667a.833.833 0 0 1-.833-.834v-1.666c0-.46.373-.834.833-.834m1.667-6.666h-1.667a.833.833 0 0 0-.833.833v1.667c0 .46.373.833.833.833h1.667c.46 0 .833-.373.833-.833V8.5a.833.833 0 0 0-.833-.833",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.highlight.light")(themeProps),
    stroke: themeGet("palette.pricePrimary.dark")(themeProps),
    d: "m8.857 34.372-.061-.016-.213-.054c-2.031-.518-3.122-2.181-3.367-3.883a4.72 4.72 0 0 1 1.159-3.823 3.7 3.7 0 0 1-.236-1.313zm0 0h.063m-.063 0h.063m0 0h2.048m-2.048 0h2.048m0 0 .07-.021m-.07.02.07-.02m0 0 .42-.125.011-.004m-.43.129.43-.129m0 0 .012-.004m-.011.004.011-.004m0 0 .041-.015m-.04.015.04-.015m0 0a4.72 4.72 0 0 0 3.018-3.352m-3.018 3.352 3.018-3.352m0 0 .01-.04.002-.01m-.012.05.012-.05m0 0 .003-.012m-.003.011.003-.011m0 0 .057-.305.002-.012m-.06.317.06-.317m0 0 .002-.011m-.002.011.002-.011m0 0 .006-.04a4.7 4.7 0 0 0-1.186-3.831 3.75 3.75 0 0 0-.31-3.234 3.77 3.77 0 0 0-4.224-1.68 3.756 3.756 0 0 0-2.763 3.607zM40.564 34.372l-.061-.016-.213-.054c-2.03-.518-3.122-2.181-3.367-3.883a4.72 4.72 0 0 1 1.159-3.823 3.7 3.7 0 0 1-.236-1.313zm0 0h.063m-.063 0h.063m0 0h2.048m-2.048 0h2.048m0 0 .07-.021m-.07.02.07-.02m0 0 .42-.125.012-.004m-.432.129.432-.129m0 0 .011-.004m-.011.004.011-.004m0 0 .041-.015m-.04.015.04-.015m0 0a4.72 4.72 0 0 0 3.018-3.352m-3.018 3.352 3.018-3.352m0 0 .01-.04.002-.01m-.012.05.012-.05m0 0 .002-.012m-.002.011.002-.011m0 0 .058-.305.002-.012m-.06.317.06-.317m0 0 .002-.011m-.002.011.002-.011m0 0 .006-.04a4.7 4.7 0 0 0-1.186-3.831 3.75 3.75 0 0 0-.31-3.234 3.77 3.77 0 0 0-4.224-1.68 3.756 3.756 0 0 0-2.763 3.607z"
  }), React.createElement("path", {
    fill: themeGet("palette.text.heading")(themeProps),
    fillRule: "evenodd",
    d: "M31.582 27.667c.41 0 .75.294.82.683l.013.15V36H19.082v-7.5c0-.41.295-.75.684-.82l.15-.013z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.tint")(themeProps),
    fillRule: "evenodd",
    d: "M25.248 28.67h-5.17v7.1h5.17zm6.172 0h-5.17v7.1h5.17z",
    clipRule: "evenodd"
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "HotelsFillGreenOnBlue_tsx__a",
    width: 50.207,
    height: 48,
    x: 0.668,
    y: -1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 2
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.12 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_5631"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 1
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.16 0"
  }), React.createElement("feBlend", {
    in2: "effect1_dropShadow_258_5631",
    result: "effect2_dropShadow_258_5631"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.24 0"
  }), React.createElement("feBlend", {
    in2: "effect2_dropShadow_258_5631",
    result: "effect3_dropShadow_258_5631"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: -1
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.03 0"
  }), React.createElement("feBlend", {
    in2: "effect3_dropShadow_258_5631",
    result: "effect4_dropShadow_258_5631"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect4_dropShadow_258_5631",
    result: "shape"
  }))));
}
const HotelsFillGreenOnBlue = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(HotelsFillGreenOnBlue);
export default Memo;